module.exports = __webpack_public_path__ + "img/ae.600ba9b9.svg";